import { colours, common, fonts } from './rebrand';

/**
 * @typedef {Object} ColourStates
 * @property {string|Colour} backgroundColour
 * @property {string|Colour} hoverBackgroundColour
 * @property {string|Colour} focusBackgroundColour
 * @property {string|Colour} activeBackgroundColour
 * @property {string|Colour} fontColour
 * @property {string|Colour} hoverFontColour
 * @property {string|Colour} focusFontColour
 * @property {string|Colour} activeFontColour
 * @property {string|Colour} borderColour
 * @property {string|Colour} hoverBorderColour
 * @property {string|Colour} focusBorderColour
 * @property {string|Colour} activeBorderColour
 */

/**
 * Fills in a ColourStates object. The order of precedence is: unprefixed, hover, focus, active.
 * Eg: `backgroundColour`, `hoverBackgroundColour`, `focusBackgroundColour`, `activeBackgroundColour`.
 *
 * For example, if `base.backgroundColour` is `#FFFFFF` and `base.hoverBackgroundColour` is undefined,
 * then `hoverBackgroundColour` will be `#FFFFFF`.
 * @param {ColourStates} base - Used as the source/default values for higher states
 * @param {string|Colour} [fallback='transparent'] - Fallback colour for `base.borderColour`
 * @returns {ColourStates} A complete ColourStates object
 */
const getColourStates = (base, fallback = 'transparent') => {
  const { backgroundColour, fontColour, borderColour = fallback } = base;
  const { hoverBackgroundColour = backgroundColour, hoverFontColour = fontColour, hoverBorderColour = borderColour } = base;
  const { focusBackgroundColour = hoverBackgroundColour, focusFontColour = hoverFontColour, focusBorderColour = hoverBorderColour } = base;
  const {
    activeBackgroundColour = focusBackgroundColour,
    activeFontColour = focusFontColour,
    activeBorderColour = focusBorderColour
  } = base;

  return {
    backgroundColour,
    hoverBackgroundColour,
    focusBackgroundColour,
    activeBackgroundColour,
    fontColour,
    hoverFontColour,
    focusFontColour,
    activeFontColour,
    borderColour,
    hoverBorderColour,
    focusBorderColour,
    activeBorderColour
  };
};

export { colours, common, fonts, getColourStates };
